/** Schlichte Linien-Icons für Kamera, Übersicht und Ecken-Editor. */
export type ScanIconName =
  | "x" | "zurueck" | "kamera" | "galerie" | "blitz" | "blitzAus"
  | "anpassen" | "filter" | "drehen" | "wiederholen" | "loeschen" | "plus" | "haken" | "warnung";

const PFADE: Record<ScanIconName, React.ReactNode> = {
  x: <path d="M6 6l12 12M18 6L6 18" />,
  zurueck: <path d="M15 5l-7 7 7 7" />,
  kamera: (
    <>
      <path d="M4 8.5h3l1.6-2.4h6.8L17 8.5h3a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1z" />
      <circle cx="12" cy="13" r="3.6" />
    </>
  ),
  galerie: (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2.4" />
      <path d="M3.5 16l4.5-4 3.5 3 3-2.5 6 5" />
      <circle cx="8" cy="9.5" r="1.6" />
    </>
  ),
  blitz: <path d="M13 2 4 14h6l-1 8 9-12h-6z" />,
  blitzAus: (
    <>
      <path d="M13 2 4 14h4" />
      <path d="M11 22l1-8h5l-3 4" />
      <path d="M3 3l18 18" />
    </>
  ),
  anpassen: (
    <>
      <path d="M6 3v13a2 2 0 0 0 2 2h13" />
      <path d="M3 6h13a2 2 0 0 1 2 2v13" />
    </>
  ),
  filter: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 3.5v17" />
      <path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none" />
    </>
  ),
  drehen: (
    <>
      <path d="M20 11a8 8 0 1 1-2.6-5.9" />
      <path d="M20 4v5h-5" />
    </>
  ),
  wiederholen: (
    <>
      <path d="M4 8.5h3l1.6-2.4h6.8L17 8.5h3a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1z" />
      <path d="M14.6 12.2A2.8 2.8 0 1 0 14 15" />
      <path d="M15 10.5v2h-2" />
    </>
  ),
  loeschen: (
    <>
      <path d="M4 7h16" />
      <path d="M9.5 7V4.5h5V7" />
      <path d="M6 7l1 13h10l1-13" />
      <path d="M10 11v5M14 11v5" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  haken: <path d="M5 12.5 10 17 19 7" />,
  warnung: (
    <>
      <path d="M12 3.5 2.8 19.5h18.4z" />
      <path d="M12 10v4.5M12 17.2v.3" />
    </>
  ),
};

export function ScanIcon({ name }: { name: ScanIconName }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PFADE[name]}
    </svg>
  );
}
